import axios from 'axios';
import host from './host';
import { formatUrl } from '../utils/api';
import { getStorage } from '../utils/storage';

var api = axios.create({
  baseURL: host + '/api',
});

api.interceptors.request.use((config) => {
  const token = getStorage('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchApi = {
  get: (urlPattern, ...args) => api.get(formatUrl(urlPattern, ...args)),
  post: (urlPattern, data, ...args) =>
    api.post(formatUrl(urlPattern, ...args), data),
  put: (urlPattern, data, ...args) =>
    api.put(formatUrl(urlPattern, ...args), data),
  delete: (urlPattern, ...args) => api.delete(formatUrl(urlPattern, ...args)),
};

export default api;
